import { format, isSameDay, isSameYear, parseISO, startOfDay } from "date-fns"
import type { GroupableRow } from "../reducers/messagesSlice"
import i18n from "@/lib/i18n/i18n"
import { getDateFnsLocale } from "@/lib/i18n/format"

export const areMessageFromDifferentDay = (
  message1: GroupableRow,
  message2: GroupableRow,
) =>
  !isSameDay(getCurrentMessageDate(message1), getCurrentMessageDate(message2))

export const getCurrentMessageDate = (messageOrGroup: GroupableRow) => {
  const timestamp =
    "timestamp" in messageOrGroup
      ? messageOrGroup.timestamp
      : messageOrGroup.messages[0].timestamp

  return startOfDay(parseISO(timestamp))
}

/**
 * The time a message bubble prints next to its author.
 *
 * Today's messages keep the bare hour. Anything older carries its date too
 * (and the year once it is no longer this year), so a dispatcher reading back
 * through history sees when a message was sent without hovering it or
 * catching the floating day pill before it fades.
 */
export const formatMessageTimestamp = (
  date: Date,
  now: Date = new Date(),
): string => {
  if (isSameDay(date, now)) return format(date, "HH:mm")
  const locale = getDateFnsLocale()
  if (isSameYear(date, now))
    return format(date, i18n.t("app.dates.messageTimeThisYear"), { locale })
  return format(date, i18n.t("app.dates.messageTimeOtherYear"), { locale })
}
